<tmo-dynamic-modal [modal]="paymentDisclaimerModal">
  <ng-container header>
    <div class="modal-logo-close">
      <em class="logo-icon t-icon t-icon-logo"></em
      ><a
        href="javascript:void(0)"
        class="close-x pull-right"
        (click)="closePaymentDisclaimerModal()"
        id="cta-default-209"
        ><em class="fa fa-times"></em
      ></a>
    </div>
    <h3>{{ modalHeading }}</h3>
  </ng-container>
  <p class="small">{{ modalText }}</p>
  <ng-container footer>
    <div class="row">
      <div *ngIf="isAccountClosed" class="col-12 button-spacing-legal">
        <button
          class="btn btn-primary"
          (click)="closePaymentDisclaimerModal()"
          id="btn-default-252"
        >
          {{ configurableAemData?.close }}
        </button>
      </div>
      <div *ngIf="!isAccountClosed" class="col-12 buttons-container button-spacing">
        <div class="button-box">
          <button
            class="btn btn-secondary"
            (click)="closePaymentDisclaimerModal()"
            id="btn-default-cancel"
          >
            {{ configurableAemData?.cancel }}
          </button>
        </div>
        <div class="button-box">
          <button
            class="btn btn-primary"
            (click)="redirectTo()"
            id="btn-button-continue"
            type="button"
          >
            {{ configurableAemData?.continue }}
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</tmo-dynamic-modal>
